import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineIncrease = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9 9.41 13.415 5 15.5 7l.5-.5V1h-5.5l-.5.5 2 2.086-2.997 2.997L6 3.58.002 9.578 1.416 11 6 6.408zM16 13H0v2h16z"
	})
});
export default SvgChartLineIncrease;
